var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$apollo.loading)?_c('div',[_vm._v("\n    "+_vm._s(_vm.$t("common:loading.messsage", "Loading...", "Loading message"))+"\n  ")]):(_vm.displayOrganisation)?_c(_vm.noLink ? 'div' : 'router-link',{tag:"component",staticClass:"no-default-link-style",class:_vm.muted ? 'muted--text' : '',attrs:{"to":{
      name: 'OrganisationProfilePage',
      params: { organisationId: _vm.displayOrganisation.id }
    }}},[_vm._v("\n    "+_vm._s(_vm.shortName
        ? _vm.displayOrganisation.shortName || _vm.displayOrganisation.name
        : _vm.displayOrganisation.name)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }